// extracted by mini-css-extract-plugin
module.exports = {"flex":"Editor_flex__2pUbM"};